import React from 'react';
import { Button } from '@/ui/components/atoms/Button';
import './EmptyState.styles.css';

interface EmptyStateProps {
  title?: string;
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
  type?: 'default' | 'no-tasks' | 'no-results' | 'success';
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  message = 'Aucune tâche pour le moment',
  actionLabel,
  onAction,
  type = 'no-tasks'
}) => {
  const getIcon = () => {
    switch (type) {
      case 'no-tasks':
        return (
          <div className="mes-taches-empty-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M9 11l3 3L22 4" />
              <path d="M20 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
            </svg>
          </div>
        );
      case 'no-results':
        return (
          <div className="mes-taches-empty-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.35-4.35" />
            </svg>
          </div>
        );
      case 'success':
        return (
          <div className="mes-taches-empty-icon success">
            😎
          </div>
        );
      default:
        return null;
    }
  };

  const getTitle = () => {
    if (title) return title;
    
    switch (type) {
      case 'no-tasks':
        return 'Aucune tâche en attente';
      case 'no-results':
        return 'Aucun résultat trouvé';
      case 'success':
        return 'Tout est à jour !';
      default:
        return 'Aucune donnée';
    }
  };

  return (
    <div className="mes-taches-empty-state">
      {getIcon()}
      <h3 className="mes-taches-empty-title">{getTitle()}</h3>
      <p className="mes-taches-empty-message">{message}</p>
      {actionLabel && onAction && (
        <Button
          variant="primary"
          onClick={onAction}
          className="mes-taches-empty-action"
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
};